import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { tokenStorage } from '../../shared/api/storage';
import { useMe } from 'core/me/provider/MeProvider';

export function ProtectedRoute({ children }) {
  const loc = useLocation();
  const tokens = tokenStorage.get();
  const { me, loading } = useMe();

  // 1) Token yoksa direkt login
  if (!tokens?.accessToken) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }

  // ✅ 2) Token var ama me daha yüklenmedi -> HİÇBİR ŞEY YAPMA (redirect yok, ekran yok)
  // Bu satır "onboarding flash" olayını bitirir.
  if (loading) return null; // istersen burada loader da koyabilirsin

  // 3) Token var ama me gelmedi/invalid -> login
  if (!me) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }

  // 4) Email doğrulama gerekiyorsa
  if (me.status === 'PENDING_EMAIL') {
    return <Navigate to="/verify-email" replace state={{ email: me.email }} />;
  }

  return <>{children}</>;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
